import DomainsLogin from '../components/Domains/DomainsLogin.vue'

let routes = {
    path: '/domains',
    component: resolve => require(['../components/layout/Login'], resolve),
    children: [
      {
          path: '/domains/login',
          name: 'DomainsLogin',
          component: DomainsLogin
      },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/domainsLogin.js